import {css} from "styled-components";
import {getColor} from "@/pipes/theme.pipe";

const colorOptions = {
    brand: css`
        color: ${getColor('brand')};
    `,
    primary: css`
        color: ${getColor('primary')};
    `,
    secondary: css`
        color: ${getColor('natural', '900')};
    `,
    dark: css`
        color: ${getColor('natural', '100')};
    `
};
export const getColorStyles = ({color}) => colorOptions[color] ?? colorOptions['dark']